import useIsSaleCountry from "./useIsSaleCountry.js";
const useIsBR = () => {
    return useIsSaleCountry("br");
};
export default useIsBR;
